<template>
<v-row no-gutters class="pr-2">
  <v-col v-if="!isLoading"  class="drop--overview--context__component pa-2" cols="12">
    <ContextTitle :title="$t('shipments.shipped_by') + ' ' + computedCarrier.carrier" class="drop--detail__title"/>
    <ContextItemAutoComplete
      :iconTooltip="$t('shipments.driver')"
      :icon="'fas fa-user'"
      :value="computedDriver"
      :bottom="false"
      :list="driverList"
      :eventName="'click'"
      @autocompleteSave="changeDriver"
    >
    </ContextItemAutoComplete>
    <ContextItemAutoComplete
      :iconTooltip="$t('fleet.vehicle')"
      :icon="'fas fa-truck'"
      :value="computedVehicle"
      :bottom="false"
      :list="vehicleList"
      :eventName="'click'"
      @autocompleteSave="changeVehicle"
    >
    </ContextItemAutoComplete>
    <GoodsValueEditableField 
      :goodsValue="shipmentDetails.goodsValue"
    />
    <ContextItem
      :iconTooltip="$t('orders.total_weight_2')"
      :icon="'fas fa-box'"
      :attribute="$t('drops.total_weight_is')"
      :value="`${$options.filters.roundValueWeight(shipmentDetails.weight, 0)} kg`"
    />
    <ContextItem
      :iconTooltip="$t('orders.total_volume_2')"
      :icon="'fas fa-arrows-alt'"
      :attribute="$t('drops.total_volume_is')"
      :value="`${$options.filters.roundValue(shipmentDetails.volume, 1)} m³`"
    />
    <ContextLabel
    :iconTooltip="$t('drops.total_units')"
    :icon="'fas fa-cube'"
    :labels="computedShipmentUnitsLabels"
    class="drop--detail--info__labels"
    v-show="computedShipmentUnitsLabels.length > 0"
    />
    <ContextItemLabels
    :isEditable="true"
    :iconTooltip="$t('shipments.labels')"
    :labels="computedShipmentLabels"
    :eventName="'click'"
    :algoliaSearchLabels="{ index: 'prod_shipments' }"
    @handleSaveLabels="handleSaveLabels"
    />
  </v-col>
  <v-col v-else  class="drop--overview--context__component pa-2" cols="12">
    <div v-for="(key, index) in new Array(7)" :key="index" class="placeholderLoader background--transparent empty--content">
    </div>
  </v-col>
</v-row>
</template>

<script>
import ContextTitle from '@/components/drops/detail/ContextTitle'
import ContextItemAutoComplete from '@/components/wrld/generic/ContextItemAutoComplete'
import ContextItem from '@/components/wrld/generic/ContextItem'
import ContextLabel from '@/components/drops/detail/ContextLabel'
import ContextItemLabels from '@/components/wrld/generic/ContextItemLabels'
import GoodsValueEditableField from '@/components/shipments/new/GoodsValueEditableField'

import { mapActions, mapGetters } from 'vuex'
import { uuid } from 'vue-uuid'
export default {
  name: 'ShipmentsContextShippedBy',
  components: {
    ContextTitle,
    ContextItemAutoComplete,
    ContextItem,
    ContextLabel,
    ContextItemLabels,
    GoodsValueEditableField,
  },
  props: {
    shipmentDetails: { value: Object | String, default: () => {} },
    isLoading: { type: Boolean, default: false }
  },
  data () {
    return {
      driverList: [],
      vehicleList: [],
      defaultStatus: 'On The Way',
      driverInputValue: null,
      vehicleInputValue: null,
      localData: null
    }
  },
  mounted () {
    this.localData = { ...this.shipmentDetails }
  },
  methods: {
    ...mapActions({
      setShipmentLabels: 'setShipmentLabels',
      setShipmentAssignedDriverList: 'setShipmentAssignedDriverList',
      setShipmentAssignedVehicleList: 'setShipmentAssignedVehicleList',
      assignShipmentDriver: 'assignShipmentDriver',
      assignShipmentVehicle: 'assignShipmentVehicle'
    }),
    changeDriver (driver) {
      this.assignShipmentDriver({ shipment: {...this.shipmentDetails, driver}, driver })
    },
    changeVehicle (vehicle) {
      this.assignShipmentVehicle({ shipment: {...this.shipmentDetails, vehicle}, vehicle })
    },
    changeStatus (status, close) {
      this.defaultStatus = status
      close()
    },
    searchVehicle (value) {
      this.vehicleInputValue = value
    },
    handleSaveLabels (labels) {
      const newLabels = labels.map(({ name }) => name)
      let removed = []
      let added = []
      if (this.shipmentDetails.labels != null) {
        this.shipmentDetails.labels.forEach((label) => {
          if (newLabels.indexOf(label) < 0) {
            removed.push(label)
          }
        })
      }
      newLabels.forEach((label) => {
        if (this.shipmentDetails.labels != null) {
          if (this.shipmentDetails.labels.indexOf(label) < 0) {
            added.push(label)
          }
        } else {
          added.push(label)
        }
      })
      this.setShipmentLabels({ shipmentID: this.shipmentDetails.id, removed, added, newLabels: newLabels })
    }
  },
  computed: {
    ...mapGetters([
      'getLoggedInUserOrganizationID',
      'getShipmentAssignDriverList',
      'getShipmentAssignVehicleList',
      'getSignedInOrganization'
    ]),
    // computedAutocompleteDrivers: function () {
    //   let drivers = ['Joe Doe', 'George Doe', 'Nick Leider', 'Anna Connors', 'John Baker']
    //   drivers = drivers.map((driverName) => {
    //     return {
    //       text: driverName,
    //       id: uuid.v1()
    //     }
    //   })
    //   return drivers
    // },
    // computedAutocompleteVehicles: function () {
    //   let vehicles = ['Volvo FM9 340 (1AA1706)', 'DAF 105 XF 460 (1AA1730)', 'Scania G440 440 (1AA4569)', 'IVECO STRALIS 460 (1AB4534)', 'Mercedes Benz AXOR 1824 240 (1DA8922)', 'Scania P270 270 (1GF2133)', 'Mercedes Benz Sprinter']
    //   vehicles = vehicles.map((vehicleName) => {
    //     return {
    //       text: vehicleName,
    //       id: uuid.v1()
    //     }
    //   })
    //   return vehicles
    // },
    computedShipmentUnitsLabels: function () {
      let unitsLabels = []
      if (this.shipmentDetails.units != null) {
        this.shipmentDetails.units.forEach((unitCount) => {
          unitsLabels.push({ name: 'packages_type.' + unitCount.type, value: unitCount.count })
        })
      }
      return unitsLabels
    },
    computedDriver () {
      if (this.shipmentDetails != null && this.shipmentDetails !== 'loading') {
        if (this.shipmentDetails.driver != null) {
          if (this.shipmentDetails.driver.name != null) {
            return this.$options.filters.userFullName(this.shipmentDetails.driver.name)
          } else {
            return this.shipmentDetails.driver
          }
        }
      }
      return this.$i18n.t('shipments.add_driver')
    },
    computedVehicle () {
      if (this.shipmentDetails != null && this.shipmentDetails !== 'loading') {
        if (this.shipmentDetails.vehicle != null && this.shipmentDetails.vehicle != '') {
          if (this.shipmentDetails.vehicle.name != null) {
            return this.shipmentDetails.vehicle.name
          } else {
            return this.shipmentDetails.vehicle
          }
        }
      }
      return this.$i18n.t('shipments.add_vehicle')
    },
    computedShipmentLabels: function () {
      let shipmentLabels = []
      if (this.shipmentDetails.labels != null) {
        this.shipmentDetails.labels.forEach((label) => {
          shipmentLabels.push({ name: label, color: '#ef476f', noTranslate: true })
        })
      }
      return shipmentLabels
    },
    computedCarrier: function () {
      if (this.localData !== null) {
        if (this.localData.carrier !== undefined) {
          return { ...this.localData, carrier: this.getSignedInOrganization.name }
        }
      }
      return { carrier: this.getSignedInOrganization.name }
    }
  },
  watch: {
    getShipmentAssignDriverList: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val != null) {
          this.driverList = [...val]
        }
      }
    },
    getShipmentAssignVehicleList: {
      deep: true,
      immediate: true,
      handler: function (val, oldVal) {
        if (val != null) {
          this.vehicleList = [...val]
        }
      }
    },
    shipmentDetails: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (val != null && val != 'loading') {
          this.setShipmentAssignedDriverList({ organizationID: this.getLoggedInUserOrganizationID })
          this.setShipmentAssignedVehicleList({ organizationID: this.getLoggedInUserOrganizationID })
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
